import { FC } from "react";

import {
	LabelPosition,
	RHookFormNumberFieldWithLabel,
} from "@websential/cosmic-v20";

interface ITD1FederalSetupFieldsPanel {}
export const TD1FederalSetupFieldsPanel: FC<
	ITD1FederalSetupFieldsPanel
> = ({}) => {
	return (
		<div>
			<RHookFormNumberFieldWithLabel
				id={"basicPersonalAmountTd1Federal"}
				label="Basic Personal Amount"
				testId="Basic-Personal-Amount"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
